const reqEditBaseSteps=[  {
    target: ".j_req_e_title",
    content:
      "Displays the title of the request, including the user's name for easy identification.",
    placement: "bottom",
  },
  {
    target: ".j_req_bkbtn",
    content:
      "Click on this button to go back to request table view.",
    placement: "bottom",
  },

  {
    target: ".j_req_e_meta",
    content:
      "Provides metadata including who created the request, and when it was submitted or approved.",
    placement: "bottom",
  },
    {
    target: ".j_req_e_cmnt",
    content:
      "Add or view comments related to this request. Comments help in tracking decisions or justifications.",
    placement: "top",
  },]
export const requestDetailsEditStep = [
 ...reqEditBaseSteps,
  {
    target: ".j_req_e_details",
    content:
      "This tab consist of the basic information of the user for which the request is being created.",
    placement: "bottom",
  },
  {
    target: ".j_req_e_uInfo",
    content:
      "Displays details of the user this request is for. These fields is editable.",
    placement: "top",
  },
    {
    target: ".j_req_e_acn",
    content:
      "Use these buttons to approve, reject, or cancel the request — based on your role and permissions.",
    placement: "top",
  },
];
export const requestRolesEditSteps=[
  ...reqEditBaseSteps,
    {
    target: ".j_req_e_roles",
    content:
      "Use theis tab to look for role access being given to user.",
    placement: "bottom",
  },
    {
    target: ".j_req_e_tbl",
    content:
      "Lists all roles involved in this request. You can review or update them here if allowed.",
    placement: "top",
  },
    {
    target: ".j_req_e_acn",
    content:
      "Use these buttons to approve, reject, or cancel the request — based on your role and permissions.",
    placement: "top",
  },

]